import configureStore from './redux/configureStore';

const store = configureStore();

window.alanUi = {
    store: store,
    tabActive: true,
    micActive: false
};

export default store;